import { getGeoportailCommuneAbsoluteUrl } from '@/config/env'
import { RoutesKey } from '@/models/enums/app/RoutesKey'
import type { RouteLocationNormalizedLoaded } from 'vue-router'
import type { Router } from 'vue-router'

export const GEOPORTAIL_MODE_QUERY_KEY = 'geoportailMode'
export const GEOPORTAIL_COMMUNE_MODE_QUERY = 'communal'

/**
 * From the home (or any non-geoportail) layout: full navigation to geoportail with ?commune=.
 * From /geoportail: SPA navigation preserving other query params.
 */
export function navigateToCommuneGeoportail(
  communeTitle: string,
  router: Router,
  route: RouteLocationNormalizedLoaded,
): void {
  const name = communeTitle.trim()
  if (!name) return
  if (route.name === RoutesKey.GEOPORTAIL) {
    void router.push({
      path: '/geoportail',
      query: { ...route.query, commune: name, geoportailMode: GEOPORTAIL_COMMUNE_MODE_QUERY },
    })
    return
  }
  window.location.assign(
    getGeoportailCommuneAbsoluteUrl(name, {
      geoportailMode: GEOPORTAIL_COMMUNE_MODE_QUERY,
    }),
  )
}
